const {track,clamp}=require('./scroll-driver.js');

document.querySelectorAll('[data-intro-scene]').forEach(element=>{
 const steps=[...element.querySelectorAll('[data-intro-step]')];
 if(!steps.length)return;
 const activate=index=>steps.forEach((step,i)=>step.classList.toggle('is-current',i===index));
 track(element,rects=>{
  const current=Math.max(0,rects.findLastIndex(rect=>rect.top<innerHeight*.55));
  activate(current);
  element.style?.setProperty('--intro-progress',clamp((innerHeight*.9-rects[0].top+innerHeight*.5)/(innerHeight*.8)).toFixed(3));
  rects.forEach((rect,i)=>{
   const entry=clamp((innerHeight*.95-rect.top)/(innerHeight*.6));
   steps[i].style.setProperty('--intro-fill',entry.toFixed(3));
   steps[i].style.setProperty('--intro-offset',`${((1-entry)*24).toFixed(2)}px`);
  });
 },()=>steps.map((step,index)=>{
  const rect=step.getBoundingClientRect();
  // Remove our own translation to keep scroll measurements stable.
  const stagger=typeof innerWidth==='number'&&innerWidth>=768?index*90:0;
  return {top:rect.top-(parseFloat(step.style.getPropertyValue('--intro-offset'))||0)+stagger};
 }),()=>{
  activate(0);
  element.style?.removeProperty('--intro-progress');
  steps.forEach(step=>['--intro-fill','--intro-offset'].forEach(name=>step.style.removeProperty(name)));
 });
});
